import { Container } from '@sainsburys-tech/luna-grid'
import { Button } from '@sainsburys-tech/luna-button'
import { useState } from 'react';
import PromptComponent from '../Reporting/ComponentSwitch/Components/PromptComponent';

interface ReportIncidentProps {
  onClick: () => void;
}

const ReportIncident = ({ onClick }: ReportIncidentProps) => {

  const [showPrompt, setShowPrompt] = useState(false)
  
  const handleOnClick = () => {
    if (sessionStorage.getItem('draftId')) {
      sessionStorage.removeItem('draftId')
    }
    if (sessionStorage.getItem('investigationId')) {
      sessionStorage.removeItem('investigationId')
    }
    sessionStorage.setItem('enforcementContact', sessionStorage.getItem('enforcementContact') === 'true' ? 'false' : 'false');
    setShowPrompt(true)
  }

  function handlePromptResponse (response: boolean) {
    setShowPrompt(false)
    if (response) {
      onClick()
    }
  }

  return (
    <>
      {showPrompt ? <PromptComponent 
        title={'Report a new incident'} 
        body={'Would you like to create a new incident report?'} 
        text={'Yes'} 
        icon={'BlueInfoIcon'}
        classification=''
        handleResult={handlePromptResponse} />
      : null}

      <Container className="ln-u-padding-ends*3" size="xs">
        <Button
          id="s-report-safety-accident"
          className="ln-u-bg-color-white report-button report-button-mobile"
          variant="outlined"
          disabled={false}
          element="button"
          onClick={handleOnClick}
          >
          Report a safety incident
        </Button>
      </Container>
    </>
  );
};

export default ReportIncident;